import { useCookies } from 'react-cookie';
import { Link } from 'react-router-dom';

import Button from '../ui/button';

import { AuthRoutes } from '@/interfaces/auth/AuthRoutes.enum';
import { StoredCookies } from '@/interfaces/auth/cookies.enum';

export default function Action() {
	const [cookies] = useCookies([
		StoredCookies.USERNAME,
		StoredCookies.REFRESH_TOKEN,
	]);

	const connected =
		!!cookies[StoredCookies.REFRESH_TOKEN] && !!cookies[StoredCookies.USERNAME];

	if (connected) {
		return (
			<Link to={AuthRoutes.SignOut}>
				<Button
					data-test="sign-out"
					transition="none"
					color="white"
					glassy={true}
				>
					Sign Out
				</Button>
			</Link>
		);
	}

	return (
		<div className="relative group">
			<Link
				className="glassy-shadow-inset-inward rounded-3xl px-5 inline-block p-2"
				to={AuthRoutes.SignIn}
			>
				<span className="flex gap-2 items-center justify-center">
					<span>Sign In</span>
				</span>
			</Link>
		</div>
	);
}
